export default __webpack_public_path__ + "static/product-unit-2-tea-c84d247f7f948caaa079d64240e929b7.png";